import { QueryClient } from '@tanstack/react-query'

/**
 * Searches in the portal are explicit user actions, so queries are never considered stale on
 * their own - a refetch only happens when the query key (search criteria/pagination) changes.
 */
export const createQueryClient = (): QueryClient =>
    new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: Number.POSITIVE_INFINITY,
                gcTime: 5 * 60 * 1000,
                retry: false,
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
            },
        },
    })

export const appQueryClient = createQueryClient()

export const clearAppQueryCache = () => {
    appQueryClient.clear()
}
